module.exports = __webpack_public_path__ + "static/media/icon-star.c5fb73f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-star.svg
// module id = 1095
// module chunks = 0